
import { Link } from 'react-router-dom';
import Navigation from '../../home/components/Navigation';
import Footer from '../../home/components/Footer';

const CrmAutomationPage = () => {
  const scrollToContact = () => {
    const contactSection = document.getElementById('contact-section');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="min-h-screen" style={{ backgroundColor: '#F8F4EF' }}>
      <Navigation />
      
      {/* Hero Section */}
      <section className="pt-32 pb-20">
        <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
          <h1 
            className="text-5xl lg:text-6xl font-bold mb-6"
            style={{ color: '#2B2B2B', fontFamily: 'Manrope, Inter, sans-serif' }}
          >
            CRM Process Automation
          </h1>
          <p 
            className="text-2xl mb-10"
            style={{ color: '#2B2B2B', fontFamily: 'Inter, sans-serif' }}
          >
            Connect your team, data, and workflows inside one centralized system.
          </p>
          <button
            onClick={scrollToContact}
            className="inline-flex items-center px-8 py-4 rounded-lg font-semibold text-white text-lg transition-all duration-300 hover:shadow-lg whitespace-nowrap cursor-pointer"
            style={{ backgroundColor: '#7B6655' }}
          >
            Schedule Workflow Audit
            <i className="ri-calendar-line ml-2"></i>
          </button>
        </div>
      </section>

      {/* Content Sections */}
      <section className="py-16">
        <div className="max-w-4xl mx-auto px-6 lg:px-8">
          
          {/* Who This Is For */}
          <div className="mb-16">
            <h2 
              className="text-3xl font-bold mb-8"
              style={{ color: '#2B2B2B', fontFamily: 'Manrope, Inter, sans-serif' }}
            >
              Who This Is For
            </h2>
            <div className="space-y-4">
              <div className="flex items-start">
                <i className="ri-check-line text-2xl mr-4 mt-1" style={{ color: '#7B6655' }}></i>
                <p className="text-lg" style={{ color: '#2B2B2B', fontFamily: 'Inter, sans-serif' }}>
                  Organizations with scattered or inconsistent data tracking
                </p>
              </div>
              <div className="flex items-start">
                <i className="ri-check-line text-2xl mr-4 mt-1" style={{ color: '#7B6655' }}></i>
                <p className="text-lg" style={{ color: '#2B2B2B', fontFamily: 'Inter, sans-serif' }}>
                  Teams who rely on manual updates and reminders
                </p>
              </div>
              <div className="flex items-start">
                <i className="ri-check-line text-2xl mr-4 mt-1" style={{ color: '#7B6655' }}></i>
                <p className="text-lg" style={{ color: '#2B2B2B', fontFamily: 'Inter, sans-serif' }}>
                  Leadership needing clearer visibility into activity and outcomes
                </p>
              </div>
            </div>
          </div>

          {/* What's Included */}
          <div className="mb-16">
            <h2 
              className="text-3xl font-bold mb-8"
              style={{ color: '#2B2B2B', fontFamily: 'Manrope, Inter, sans-serif' }}
            >
              What's Included
            </h2>
            <div className="space-y-4">
              <div className="flex items-start">
                <i className="ri-arrow-right-line text-2xl mr-4 mt-1" style={{ color: '#7B6655' }}></i>
                <p className="text-lg" style={{ color: '#2B2B2B', fontFamily: 'Inter, sans-serif' }}>
                  CRM configuration and customization
                </p>
              </div>
              <div className="flex items-start">
                <i className="ri-arrow-right-line text-2xl mr-4 mt-1" style={{ color: '#7B6655' }}></i>
                <p className="text-lg" style={{ color: '#2B2B2B', fontFamily: 'Inter, sans-serif' }}>
                  Automated data flow and record syncing
                </p>
              </div>
              <div className="flex items-start">
                <i className="ri-arrow-right-line text-2xl mr-4 mt-1" style={{ color: '#7B6655' }}></i>
                <p className="text-lg" style={{ color: '#2B2B2B', fontFamily: 'Inter, sans-serif' }}>
                  Task routing + follow-up automation
                </p>
              </div>
              <div className="flex items-start">
                <i className="ri-arrow-right-line text-2xl mr-4 mt-1" style={{ color: '#7B6655' }}></i>
                <p className="text-lg" style={{ color: '#2B2B2B', fontFamily: 'Inter, sans-serif' }}>
                  Reporting dashboards and insights
                </p>
              </div>
            </div>
          </div>

          {/* Key Outcomes */}
          <div className="mb-16">
            <h2 
              className="text-3xl font-bold mb-8"
              style={{ color: '#2B2B2B', fontFamily: 'Manrope, Inter, sans-serif' }}
            >
              Key Outcomes / Benefits
            </h2>
            <div className="space-y-4">
              <div className="flex items-start">
                <i className="ri-star-line text-2xl mr-4 mt-1" style={{ color: '#7B6655' }}></i>
                <p className="text-lg" style={{ color: '#2B2B2B', fontFamily: 'Inter, sans-serif' }}>
                  Better team coordination
                </p>
              </div>
              <div className="flex items-start">
                <i className="ri-star-line text-2xl mr-4 mt-1" style={{ color: '#7B6655' }}></i>
                <p className="text-lg" style={{ color: '#2B2B2B', fontFamily: 'Inter, sans-serif' }}>
                  Reliable reporting and decision-making
                </p>
              </div>
              <div className="flex items-start">
                <i className="ri-star-line text-2xl mr-4 mt-1" style={{ color: '#7B6655' }}></i>
                <p className="text-lg" style={{ color: '#2B2B2B', fontFamily: 'Inter, sans-serif' }}>
                  Fewer missed tasks and follow-ups
                </p>
              </div>
            </div>
          </div>

          {/* Timeline & Pricing */}
          <div className="grid md:grid-cols-2 gap-12 mb-16">
            <div>
              <h2 
                className="text-3xl font-bold mb-6"
                style={{ color: '#2B2B2B', fontFamily: 'Manrope, Inter, sans-serif' }}
              >
                Timeline
              </h2>
              <p className="text-2xl font-semibold" style={{ color: '#7B6655', fontFamily: 'Inter, sans-serif' }}>
                3–6 weeks
              </p>
            </div>
            <div>
              <h2 
                className="text-3xl font-bold mb-6"
                style={{ color: '#2B2B2B', fontFamily: 'Manrope, Inter, sans-serif' }}
              >
                Typical Pricing Range
              </h2>
              <p className="text-2xl font-semibold" style={{ color: '#7B6655', fontFamily: 'Inter, sans-serif' }}>
                $4,000–$7,500
              </p>
            </div>
          </div>

          {/* CTA Section */}
          <div id="contact-section" className="text-center bg-white p-12 rounded-2xl shadow-sm border" style={{ borderColor: '#E6DACD' }}>
            <h2 
              className="text-3xl font-bold mb-6"
              style={{ color: '#2B2B2B', fontFamily: 'Manrope, Inter, sans-serif' }}
            >
              Ready to Centralize Your Operations?
            </h2>
            <p 
              className="text-xl mb-8 max-w-2xl mx-auto"
              style={{ color: '#2B2B2B', fontFamily: 'Inter, sans-serif' }}
            >
              Schedule a free workflow audit to design your automated CRM system and improve team coordination.
            </p>
            <button
              className="inline-flex items-center px-8 py-4 rounded-lg font-semibold text-white text-lg transition-all duration-300 hover:shadow-lg whitespace-nowrap cursor-pointer"
              style={{ backgroundColor: '#7B6655' }}
            >
              Schedule Your Free Workflow Audit
              <i className="ri-calendar-line ml-2"></i>
            </button>
            
            {/* Cross-link to How We Work */}
            <div className="mt-8 pt-6 border-t" style={{ borderColor: '#E6DACD' }}>
              <p className="text-base" style={{ color: '#2B2B2B', fontFamily: 'Inter, sans-serif' }}>
                Want our full implementation framework? 
                <Link 
                  to="/services/how-we-work" 
                  className="ml-1 font-medium transition-colors duration-200 cursor-pointer hover:opacity-80"
                  style={{ color: '#7B6655' }}
                >
                  See How We Work →
                </Link>
              </p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default CrmAutomationPage;
